export type GrapeAPIErrorType = {
  status: number;
  message: string;
  errors: Array<string>;
  fieldErrors?: Record<string, string[]>;
  requestId?: string;
}

export function GrapeAPIError ({
  status,
  message,
  errors,
  fieldErrors,
  requestId
}: GrapeAPIErrorType) {
  return {
    status,
    message,
    errors,
    fieldErrors,
    requestId
  }
}
